import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { FlowNavigationService } from 'src/app/Services/flow-navigation.service';
import { MatDialog } from '@angular/material/dialog';
import {
  hasAiCreationAccess,
  hasContentCreationPlanAccess,
  showSmartCreatePaidBadge,
} from 'src/app/shared/utils/plan.util';
import { isTrialActive, isTrialGuideLimitReached } from 'src/app/shared/utils/trial.util';
import { openTrialUpgradeDialog } from 'src/app/shared/utils/trial-gate.util';
import { setCoinPurchaseReturnUrl } from 'src/app/shared/utils/coin-purchase-return.util';
import { FrontlineFeatureFlags } from 'src/app/shared/constants/frontline-glossary';

@Component({
  selector: 'app-create-flow-selection',
  templateUrl: './create-flow-selection.component.html',
  styleUrls: ['./create-flow-selection.component.scss']
})
export class CreateFlowSelectionComponent implements OnInit, OnDestroy {
  isMobileView: boolean = false;
  userData: any = null;
  showSmartCreatePaidBadge = false;
  isLoggedIn = false;
  readonly showCoinPurchaseLinks = FrontlineFeatureFlags.showCoinPurchaseLinks;

  aiCreationLocked = false;
  isTrial = false;

  constructor(
    private router: Router,
    private flowNavigationService: FlowNavigationService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    document.body.style.overflow = 'hidden';
    this.checkMobileView();
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser") || "null");
    this.isLoggedIn = !!this.userData;
    this.showSmartCreatePaidBadge = showSmartCreatePaidBadge(this.userData);
    this.aiCreationLocked = !hasAiCreationAccess(this.userData);
    this.isTrial = isTrialActive();
  }

  ngOnDestroy() {
    document.body.style.overflow = '';
  }

  checkMobileView() {
    this.isMobileView = window.innerWidth <= 768;
    window.addEventListener('resize', () => {
      this.isMobileView = window.innerWidth <= 768;
    });
  }

  navigateToSmartCreate() {
    this.clearFlowDraftStorage();
    if (!hasContentCreationPlanAccess(this.userData)) {
      setCoinPurchaseReturnUrl(this.router.url);
      this.router.navigate(["/pricing"], {
        queryParams: { buyCoins: "1", returnUrl: this.router.url },
        fragment: "ai-coins",
      });
      return;
    }
    if (this.aiCreationLocked) {
      openTrialUpgradeDialog(this.dialog, "trial-ai", this.router.url);
      return;
    }
    this.router.navigate(["/create-guide/quick"]);
  }

  /** @deprecated Use navigateToSmartCreate */
  navigateToAiCreate() {
    this.navigateToSmartCreate();
  }

  /** @deprecated Use navigateToSmartCreate */
  navigateToQuickCreate() {
    this.navigateToSmartCreate();
  }

  private clearFlowDraftStorage(): void {
    localStorage.removeItem("ItemsRequired");
    localStorage.removeItem("flowCoverPageDetails");
    localStorage.removeItem("SupportingDocumentDocuments");
    localStorage.removeItem("SupportingDocumentHyperLinksRequired");
    localStorage.removeItem("stepsCoverPageDetails");
    localStorage.removeItem("draftWord");
    localStorage.removeItem("editWord");
  }

  navigateToManualCreate() {
    this.clearFlowDraftStorage();
    if (!hasContentCreationPlanAccess(this.userData)) {
      this.router.navigate(["/pricing"]);
      return;
    }
    if (isTrialGuideLimitReached()) {
      openTrialUpgradeDialog(this.dialog, "trial-guides", this.router.url);
      return;
    }
    this.router.navigate(['/create-guide/manual']);
  }

  goBack() {
    this.flowNavigationService.navigateBack();
  }

  goToPricingCoins(event?: Event): void {
    event?.stopPropagation();
    setCoinPurchaseReturnUrl(this.router.url);
    this.router.navigate(["/pricing"], {
      queryParams: { buyCoins: "1", returnUrl: this.router.url },
      fragment: "ai-coins",
    });
  }

  goToPurchaseCoins(event?: Event): void {
    event?.stopPropagation();
    setCoinPurchaseReturnUrl(this.router.url);
    this.router.navigate(["/pricing"], {
      queryParams: { buyCoins: "1", returnUrl: this.router.url },
      fragment: "ai-coins",
    });
  }
}
